import { render, staticRenderFns } from "./FoodTagForm.vue?vue&type=template&id=10c398f7"
import script from "./FoodTagForm.vue?vue&type=script&lang=js"
export * from "./FoodTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports